import React from "react";
import { Box, Typography } from "@material-ui/core";
import CDialog from "shared/CDialog";
import { Loading } from "shared";
import useGetExercise from "routes/createContent/api/useGetExercise";
import ExercisePreview from "routes/createContent/components/ExercisePreview";

type Props = {
  exerciseId: number | null;
  onClose: () => void;
};

// Reuses the ExercisePreview presentation from the create-content/exercises/:id
// view, fetched on demand and shown in a dialog.
const ExercisePreviewDialog: React.VFC<Props> = ({ exerciseId, onClose }) => {
  const { data, isLoading, error } = useGetExercise(exerciseId ?? undefined);
  // useGetExercise is a v2 endpoint not in the OpenAPI types, so data is untyped.
  const exercise = data as any;
  const hasContent = !!exercise?.levels?.length && !!exercise.levels[0]?.translations?.length;

  return (
    <CDialog open={exerciseId != null} onClose={onClose} maxWidth="md" fullWidth>
      <Box px={2} pb={2}>
        {isLoading && <Loading />}
        {error && <Typography color="error">Failed to load exercise.</Typography>}
        {!isLoading &&
          !error &&
          (hasContent ? <ExercisePreview exercise={exercise} /> : <Typography>No preview available.</Typography>)}
      </Box>
    </CDialog>
  );
};

export default ExercisePreviewDialog;
